import '../../styles/Table.css';
import '../../styles/main.css';
import '../../styles/JustificationPage.css'
import { useMemo } from 'react'
import { ReactComponent as IconComment } from '../../assets/Icons/icon-comment.svg'
import { ReactComponent as IconDelete } from '../../assets/Icons/icon-delete.svg'



const delta = (planned, executed) => {
	
	const result = Number(executed) - Number(planned);
  
	if (result > 0) {
	  return <span className="text-green-500">{result.toLocaleString('pt-BR')}</span>;
	}

	if (result < 0) {
	  return <span className="text-red-500">{result.toLocaleString('pt-BR')}</span>;
	}

	return <span className="text-gray-500">--</span>;
};

const status = (isJustified) => {

	if (isJustified) {
		return <span className="text-[#06aa06] px-[16px] py-0 rounded-[12px] bg-[#6bf76b70] ">Ok</span>;
	}

	return <span className="text-[#AA0657] px-[16px] py-0 rounded-[12px] bg-[#f76bc370] ">Não Ok</span>;

}

function ComparisionTable({ 
	
	tableColumns, 
	tableData, 
	onOpenJustificationFromComparision, 
	handerDeleteComparision,
	hasPermission,

	textFilter,
	setTextFilter,
	deltaFilter,
	setDeltaFilter,
	statusFilter,
	setStatusFilter

}) {

	const totals = useMemo(() => {

		if (!Array.isArray(tableData)) return { planned: 0, executed: 0, justifiedCount: 0 }

		return tableData.reduce((acc, data) => {

			acc.planned  += Number(data.planned)  || 0
			acc.executed += Number(data.executed) || 0

			if (data.isJustified) acc.justifiedCount += 1

			return acc

		}, { planned: 0, executed: 0, justifiedCount: 0 })

	}, [tableData])
		
	return (<>

			<div className="flex justify-between items-center flex-wrap gap-2 py-2">

				<div className="flex items-center gap-3 flex-wrap">

					<input
						type="text"
						value={textFilter}
						onChange={(e) => setTextFilter(e.target.value)}
						placeholder="Filtrar (separe vários termos com ;)"
						className="border rounded-[8px] px-3 py-1 text-sm w-[320px] max-w-full"
					/>

					<div className="flex items-center rounded-[8px] overflow-hidden border">

						<button
							type="button"
							onClick={() => setDeltaFilter('todos')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'todos' ? 'bg-gray-300 text-gray-800' : 'bg-white text-gray-500'}`}
						>
							Todos
						</button>

						<button
							type="button"
							onClick={() => setDeltaFilter('positivo')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'positivo' ? 'bg-[#6bf76b70] text-[#06aa06]' : 'bg-white text-gray-500'}`}
						>
							Positivo
						</button>

						<button
							type="button"
							onClick={() => setDeltaFilter('negativo')}
							className={`px-3 py-1 text-sm ${deltaFilter === 'negativo' ? 'bg-[#f76bc370] text-[#AA0657]' : 'bg-white text-gray-500'}`}
						>
							Negativo
						</button>

					</div>

					<div className="flex items-center rounded-[8px] overflow-hidden border">

						<button
							type="button"
							onClick={() => setStatusFilter('todos')}
							className={`px-3 py-1 text-sm ${statusFilter === 'todos' ? 'bg-gray-300 text-gray-800' : 'bg-white text-gray-500'}`}
						>
							Todos
						</button>

						<button
							type="button"
							onClick={() => setStatusFilter('ok')}
							className={`px-3 py-1 text-sm ${statusFilter === 'ok' ? 'bg-[#6bf76b70] text-[#06aa06]' : 'bg-white text-gray-500'}`}
						>
							Ok
						</button>

						<button
							type="button"
							onClick={() => setStatusFilter('naoOk')}
							className={`px-3 py-1 text-sm ${statusFilter === 'naoOk' ? 'bg-[#f76bc370] text-[#AA0657]' : 'bg-white text-gray-500'}`}
						>
							Não Ok
						</button>

					</div>

				</div>

				<span className="text-sm text-gray-500 italic">
					{JSON.stringify(tableData.length)} comparações.
				</span>

			</div>

			<table className="tables table-pattern-sistem w-full borda-cinza">
				
				<thead className="bg-neutro">
					
					<tr>

						<th></th>
						<th>Operação</th>
						<th>Terminal</th>
						<th>Ferrovia</th>
						<th>Produto</th>
						<th className="!text-right"><span>{tableColumns?.[0] || null}</span></th>
						<th className="!text-right"><span>{tableColumns?.[1] || null}</span></th>
						<th className="!text-right"><span>Δ</span></th>
						<th className="!text-center">Status</th>
						<th></th>
						{hasPermission && <th></th>}
						
					</tr>
					
				</thead>
				
				<tbody>
					
					{Array.isArray(tableData) && tableData.map((data, index) => (
						
						<tr key={data.id}>

							<td title={`ID: ${data.id}`} className="cursor-default">{String(index + 1).padStart(2, '0')}</td>
							
							<td>{data.ownerOperation.name} </td>
							<td>{data.ownerTerminal.name}  </td>
							<td>{data.ownerRailway.name}   </td>
							<td>{data.ownerProduct.name}   </td>
							
							<td className="text-right">  {data.planned.toLocaleString('pt-BR')}  </td>
							<td className="text-right">  {data.executed.toLocaleString('pt-BR')} </td>
							<td className="text-right">  {delta(data.planned, data.executed)}	 </td>
							<td className="text-center"> {status(data.isJustified)}				 </td>
							
							<td
								className=" text-right icon-gray cursor-pointer"
								onClick={() => onOpenJustificationFromComparision(data.id)}
							>
								<IconComment className="p-[2px]"/>
							</td>
							
							{hasPermission && 
								
								<td
									className="text-right icon-gray cursor-pointer"
									onClick={() => handerDeleteComparision(data.id)}
								>
									<IconDelete />
								</td>

							}

						</tr>
					))}
				</tbody>

				<tfoot>

					<tr className=" bg-neutro border-t border-[#e3e2e2]">

						<td colSpan={5} className="text-left px-5 py-2">Total</td>

						<td className="text-right">{totals.planned.toLocaleString('pt-BR')}</td>
						<td className="text-right">{totals.executed.toLocaleString('pt-BR')}</td>
						<td className="text-right">{delta(totals.planned, totals.executed)}</td>
						<td className="text-center">{totals.justifiedCount}/{tableData.length} justificados</td>

						<td></td>
						{hasPermission && <td></td>}

					</tr>

				</tfoot>

			</table>
		</>)

}

export default ComparisionTable;